import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';

import { availabilityPreferencesQueryKeys } from './queryKeys';

export const useAvailabilityPreferencesQuery = (userId: string | undefined) => {
  return useQuery({
    queryKey: availabilityPreferencesQueryKeys.detail(userId),
    queryFn: userId
      ? async () => {
          const { data } = await fetchClient.GET(
            endpoints.availabilityPreferences,
            {
              params: { path: { id: userId } },
            },
          );

          return data ?? null;
        }
      : skipToken,
  });
};
